import o from "../icon/src/Check.esm.js";
import e from "../icon/src/Error.esm.js";
const t = {
  componentName: "fuse-dropdown",
  icon: {
    error: {
      state: e,
      label: ""
    },
    success: {
      state: o,
      label: ""
    }
  },
  size: "small"
};
export {
  t as config
};
